import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import PropTypes from 'prop-types';
import { compose, lifecycle, withHandlers, withState } from 'recompose';

import connect from 'app/libs/connect';
import captchaRequest from 'app/features/authentication/actions/captchaRequest';
import RecaptchaContainerStyled from 'app/features/authentication/components/Recaptcha/RecaptchaContainer.styled';
import noop from 'app/libs/noop';

const RecaptchaContainer = ({
  captchaKey,
  shouldShowCaptcha,
  onCaptchaSubmit,
}) => {
  if (shouldShowCaptcha) {
    return (
      <RecaptchaContainerStyled>
        <ReCAPTCHA
          data-t="recaptcha-container"
          sitekey={captchaKey}
          onChange={onCaptchaSubmit}
        />
      </RecaptchaContainerStyled>
    );
  }

  return null;
};

RecaptchaContainer.propTypes = {
  captchaKey: PropTypes.string,
  onCaptchaSubmit: PropTypes.func.isRequired,
  shouldShowCaptcha: PropTypes.bool.isRequired,
};

RecaptchaContainer.defaultProps = {
  captchaKey: noop,
};

const onCaptchaSubmit =
  ({ onCaptchaChange, onCaptchaFieldChange, captchaFormField }) =>
  captchaValue => {
    onCaptchaChange(captchaValue);
    onCaptchaFieldChange(captchaFormField);
  };

const actions = { checkCaptcha: captchaRequest };

function componentDidMount() {
  const {
    checkCaptcha,
    formType,
    setCaptchaKey,
    setCaptchaFormField,
    setShouldShowCaptcha,
    onCaptchaChange,
    handleSubmit,
    username,
    password,
  } = this.props;

  checkCaptcha(formType).then(
    ({
      show_captcha: showCaptcha,
      public_key: publicKey,
      captcha_field: captchaField,
    }) => {
      if (showCaptcha) {
        setCaptchaKey(publicKey);
        setCaptchaFormField(captchaField);
        setShouldShowCaptcha(true);
      } else {
        onCaptchaChange(true);
        if (username && password) {
          handleSubmit();
        }
      }
    },
  );
}

export { RecaptchaContainer, componentDidMount, onCaptchaSubmit };

export default compose(
  connect(null, actions),
  withState('shouldShowCaptcha', 'setShouldShowCaptcha', false),
  withState('captchaKey', 'setCaptchaKey', null),
  withState('captchaFormField', 'setCaptchaFormField', null),
  lifecycle({ componentDidMount }),
  withHandlers({ onCaptchaSubmit }),
)(RecaptchaContainer);
